import React from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { useAuth } from "../../context/AuthContext"
import { supabase } from '../../lib/supabaseClient'
import DeleteAccountButton from '../../components/DeleteAccountButton'

const AccountPage: React.FC = () => {
  const { profile } = useAuth()
  const navigate = useNavigate()

  const handleLogout = async () => {
    await supabase.auth.signOut({ scope: 'local' })
    navigate('/order/start', { replace: true })
  }

  if (!profile) {
    return (
      <div className="card">
        <div className="card-header">
          <h1 className="card-title">Mon compte</h1>
        </div>
        <p style={{ fontSize: '0.9rem', color: '#9ca3af' }}>
          Tu dois être connecté pour accéder à ton compte.
        </p>
        <Link to="/auth/login" className="btn btn-primary">
          Se connecter
        </Link>
      </div>
    )
  }

  return (
    <div className="card">
      <div className="card-header">
        <div>
          <h1 className="card-title">Mon compte</h1>
          <p style={{ fontSize: '0.85rem', color: '#9ca3af' }}>
            Gère tes informations personnelles, ton adresse et tes raquettes préférées.
          </p>
        </div>
      </div>

      <div style={{ marginBottom: '1rem' }}>
        <h2 style={{ fontSize: '0.9rem', marginBottom: '0.25rem' }}>Bonjour 👋</h2>
        <p style={{ fontSize: '0.85rem', color: '#9ca3af' }}>
          {profile.full_name || profile.email}
        </p>
      </div>

      {/* Menu sections */}
      <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
        {/* --- Mes commandes --- */}
        <Link to="/orders" className="btn">
          Mes commandes
        </Link>

        {/* --- Informations personnelles --- */}
        <Link to="/account/personal-info" className="btn">
          Informations personnelles
        </Link>

        {/* --- Adresse --- */}
        <Link to="/account/address" className="btn">
          Adresse
        </Link>

        {/* --- Raquette --- */}
        <Link to="/account/racket" className="btn">
          Raquette (par défaut)
        </Link>

        {/* --- Sécurité / mot de passe --- */}
        <Link to="/auth/forgot-password" className="btn">
          Sécurité (Changer mon mot de passe)
        </Link>

        {/* --- Déconnexion --- */}
        <button className="btn btn-ghost" onClick={handleLogout}>
          Se déconnecter
        </button>

        {/* --- Suppression du compte --- */}
        <DeleteAccountButton />
      </div>
    </div>
  )
}

export default AccountPage
